module.exports = __webpack_public_path__ + "img/A002.fc2cbf75.svg";